import { LoadProgramUiState } from '@/store/modules/loadProgramUi/types'
import { UpgradeRequiredReason } from './models'

export const state: LoadProgramUiState = {
  interacted: false,
  upgradeRequiredReason: UpgradeRequiredReason.None,
  validationIssues: [],
}
